/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * appHeader
 */

import scrollMonitor from 'scrollmonitor';

const appHeader = {
    cfg: {
        logos: document.querySelectorAll('.a-logo'),
        section: document.querySelectorAll('.o-section--cb')
    },

    init() {
        const elementWatcher = scrollMonitor.create(this.cfg.section[0]);

        // elementWatcher.lock();

        elementWatcher.exitViewport(() => {
            this.cfg.logos.forEach((i) => {
                i.classList.remove('a-logo--is-hidden');
            });
        });

        elementWatcher.enterViewport(() => {
            this.cfg.logos.forEach((i) => {
                i.classList.add('a-logo--is-hidden');
            });
        });
    }
};

export default appHeader;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/appHeader/_script.js